// Querys and Mutations
import {
  CREATE,
  UPDATE,
  GET_WITH_PAGINATION,
  DELETE,
  GET_ALL,
  VALIDATE_EXISTS_ADVANCE_CONTROL
} from '@/graphql/dailyControl/AdvanceControlGraphQl'

// models
import { ResponseDefault, Paginator, ResponseCustom } from '@/models'
import {
  AdvanceControl,
  AdvanceControlForm,
  AdvanceControlWithPagination,
  FiltersAdvanceControl
} from '@/models/dailyControl'

// apollo
import { apolloClient } from '@/apollo'
import { getFirstErrorApollo } from '@/utils/apollo'

const filtersDefault: FiltersAdvanceControl = {
  advanceType: null,
  applyDate: null,
  employee: null,
  registerDate: null
}

class AdvanceControlService {
  /**
   * Queries
   */
  async getWithPagination (perPage = 10, page = 1, filters: FiltersAdvanceControl): Promise<AdvanceControlWithPagination> {
    const result = await apolloClient.query({
      query: GET_WITH_PAGINATION,
      variables: {
        page: page,
        perPage: perPage,
        filters: {
          ...filters,
          employee: Number(filters.employee) > 0 ? Number(filters.employee) : null,
          advanceType: Number(filters.advanceType) > 0 ? Number(filters.advanceType) : null
        }
      }
    })
    const pagination: Paginator = result.data.advanceControlWithPagination.paginatorInfo
    const data: AdvanceControl[] = result.data.advanceControlWithPagination.data
    const response: AdvanceControlWithPagination = {
      objects: data,
      pagination: pagination
    }
    return response
  }

  async getAll (filters: FiltersAdvanceControl = filtersDefault): Promise<AdvanceControl[]> {
    const result = await apolloClient.query({
        query: GET_ALL,
        variables: {
          filters: {
            ...filters,
            employee: Number(filters.employee) > 0 ? Number(filters.employee) : null,
            advanceType: Number(filters.advanceType) > 0 ? Number(filters.advanceType) : null
          }
        }
    })
    return result.data.advanceControls
  }

  /**
   * Mutations
   */
  create (form: AdvanceControlForm): Promise<ResponseCustom> {
    return apolloClient.mutate({
      mutation: CREATE,
      variables: {
        input: form
      }
    }).then(() => {
      return {
        success: true,
        msg: 'success'
      }
    }).catch(e => {
      throw getFirstErrorApollo(e)
    })
  }

  update (id: number, form: AdvanceControlForm): Promise<ResponseCustom> {
    return apolloClient.mutate({
      mutation: UPDATE,
      variables: {
        id: id,
        input: form
      }
    }).then(() => {
      return {
        success: true,
        msg: ''
      }
    }).catch(e => {
      throw getFirstErrorApollo(e)
    })
  }

  async delete (id: number): Promise<ResponseDefault> {
    await apolloClient.mutate({
      mutation: DELETE,
      variables: {
        id: id
      }
    })
    return {
      success: true,
      errors: []
    }
  }

  validateExists (id: number|null, form: AdvanceControlForm): Promise<ResponseCustom> {
    return apolloClient.mutate({
      mutation: VALIDATE_EXISTS_ADVANCE_CONTROL,
      variables: {
        id: id,
        input: form
      }
    }).then(res => {
      return {
        success: res.data.validateAdvanceControl.success,
        msg: res.data.validateAdvanceControl.msgError
      }
    }).catch(e => {
      throw getFirstErrorApollo(e)
    })
  }
}

export default new AdvanceControlService()
